import { useStore } from 'hooks';
import { observer } from 'mobx-react-lite';
import { ThemeProvider as StyledThemeProvider } from 'styled-components/macro';
import {
  GlobalStyles,
  theme,
  DSDarkColors,
  DSLightColors,
  DSDarkSemantic,
  DSLightSemantic,
} from 'styles';

export const ThemeProvider = observer(
  ({ children }: { children: React.ReactNode }) => {
    const { common } = useStore();

    return (
      <StyledThemeProvider
        theme={{
          ...theme,
          mode: common.theme,
          colors: common.theme === 'light' ? DSLightColors : DSDarkColors,
          semantic: common.theme === 'light' ? DSLightSemantic : DSDarkSemantic,
        }}
      >
        <GlobalStyles />

        {children}
      </StyledThemeProvider>
    );
  }
);
